import { render } from "./UiSettingsSidebar.vue?vue&type=template&id=6bf90c7e"
import script from "./UiSettingsSidebar.vue?vue&type=script&lang=js"
export * from "./UiSettingsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__